// example: https://github.com/marmelab/react-admin/blob/master/examples/demo/src/layout/Menu.tsx

import React from 'react'
import { FC } from 'react'

import { MenuProps, useResourceDefinitions, useGetIdentity, usePermissions, useSidebarState } from 'react-admin'
import Divider from '@mui/material/Divider'

import SubMenus from './sub_menus'

const Menu: FC<MenuProps> = (props) => {
  const { dense, onMenuClick } = props

  const { identity, isLoading: identityLoading } = useGetIdentity()
  const { isLoading: loadingPermissions, permissions } = usePermissions()
  const [open] = useSidebarState()
  const resourcesDefinitions = useResourceDefinitions()
  const resources = Object.keys(resourcesDefinitions).map((name) => resourcesDefinitions[name])

  if (identityLoading || loadingPermissions) return null

  const { account } = identity

  const filterResources = (key: string, resources: any[]): any[] => {
    return resources.filter(({ options }) => {
      if (options && options.find) {
        const menu = options.find(({ menu }: { menu?: string }) => menu && menu == key)
        if (menu != null) return true
      }

      return false
    })
  }

  if (resources.length == 0 || !permissions) return null

  const accountResources = filterResources('account', resources)
  const adminResources = filterResources('admin', resources)
  const serviceResources = filterResources('services', resources)

  const isActiveMember = account != null

  return (
    <div
      style={{
        margin: '40px 0',
      }}
    >
      {/* <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} /> */}
      {isActiveMember && (
        <SubMenus.Services dense={dense} onMenuClick={onMenuClick} resources={serviceResources} sidebarIsOpen={open} />
      )}
      {isActiveMember && (
        <SubMenus.Account dense={dense} onMenuClick={onMenuClick} resources={accountResources} sidebarIsOpen={open} />
      )}
      {permissions.includes('admin') && (
        <div className="admin-menu" style={{ marginTop: '20px' }}>
          <Divider light />
          <SubMenus.Admin dense={dense} onMenuClick={onMenuClick} resources={adminResources} sidebarIsOpen={open} />
        </div>
      )}
    </div>
  )
}

export default Menu
